var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-screen flex w-full bg-img" }, [
    _c(
      "div",
      {
        staticClass:
          "vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center",
      },
      [
        _c("vx-card", [
          _c(
            "div",
            {
              staticClass: "full-page-bg-color",
              attrs: { slot: "no-body" },
              slot: "no-body",
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg",
                  },
                  [
                    _c("validation-observer", {
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var valid = ref.valid
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "vx-logo flex justify-items-center items-center pt-4",
                                },
                                [
                                  _c("img", {
                                    staticClass: "mx-auto",
                                    staticStyle: { "max-height": "25px" },
                                    attrs: {
                                      src: require("@/assets/images/logo/logo.png"),
                                      alt: "logo",
                                    },
                                  }),
                                ]
                              ),
                              _c("div", { staticClass: "p-4" }, [
                                _c(
                                  "div",
                                  { staticClass: "vx-card__title mb-8" },
                                  [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "mb-4 grid justify-items-center",
                                      },
                                      [_vm._v("Recuperar Senha")]
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        "Por favor informe seu email e sua nova senha."
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-col gap-1" },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Email",
                                        rules: "required|email",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("vs-input", {
                                                  staticClass: "w-full",
                                                  attrs: {
                                                    type: "email",
                                                    "label-placeholder":
                                                      "Email",
                                                  },
                                                  model: {
                                                    value: _vm.email,
                                                    callback: function ($$v) {
                                                      _vm.email = $$v
                                                    },
                                                    expression: "email",
                                                  },
                                                }),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Senha",
                                        rules: "required|password",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("vs-input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value:
                                                        "required|verify_password",
                                                      expression:
                                                        "'required|verify_password'",
                                                    },
                                                  ],
                                                  ref: "password",
                                                  staticClass: "w-full",
                                                  attrs: {
                                                    type: "password",
                                                    name: "password",
                                                    "label-placeholder":
                                                      "Senha",
                                                    "data-vv-as": "password",
                                                  },
                                                  model: {
                                                    value: _vm.password,
                                                    callback: function ($$v) {
                                                      _vm.password = $$v
                                                    },
                                                    expression: "password",
                                                  },
                                                }),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Confirmação Senha",
                                        rules: "required|password:@confirm",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("vs-input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value:
                                                        "required|confirmed:password",
                                                      expression:
                                                        "'required|confirmed:password'",
                                                    },
                                                  ],
                                                  staticClass: "w-full",
                                                  attrs: {
                                                    type: "password",
                                                    name: "password_confirmation",
                                                    "label-placeholder":
                                                      "Confirmação Senha",
                                                    "data-vv-as": "password",
                                                  },
                                                  model: {
                                                    value: _vm.passwordConfirm,
                                                    callback: function ($$v) {
                                                      _vm.passwordConfirm = $$v
                                                    },
                                                    expression:
                                                      "passwordConfirm",
                                                  },
                                                }),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-wrap justify-center gap-1 sm:flex-row",
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: "primary",
                                          disabled: !valid,
                                        },
                                        on: { click: _vm.resetPassword },
                                      },
                                      [_vm._v("Recuperar")]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "float-right",
                                        attrs: {
                                          variant: "outline-secondary",
                                          to: "/login",
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "CornerUpLeftIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle" },
                                          [_vm._v(_vm._s(_vm.$t("back")))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }